export default {
	project: {
		my_xs: 'Le mie decisioni',
		fields: {
			name: 'Titolo',
			name_explanation: 'Fornisci un titolo per il tuo progetto',
			description: 'Missione',
			description_explanation: 'Stabilisci la tua missione generale',
			vision: 'Visione',
			vision_explanation: 'Esprimi la visione a lungo termine del progetto',
			description_long: 'Descrizione',
			description_long_explanation: "Es.: «PMI svizzera di meccatronica, 200 persone, mercato OEM automotive europeo. Missione: diventare il leader europeo dei sensori intelligenti entro il 2030.»",
			description_long_hint: "Più la descrizione è precisa (settore, dimensione, missione), più l'analisi è accurata.",
			description_long_warning_title: 'Descrizione breve',
			description_long_warning_body: "La tua descrizione è di {{count}} caratteri. L'IA potrebbe dedurre un settore o un contesto che non corrisponde alla tua organizzazione. Vuoi arricchirla prima di avviare?",
			description_long_warning_enrich: 'Arricchisci',
			description_long_warning_continue: 'Avvia comunque',
			ai_context: 'Focus e angoli specifici',
			ai_context_explanation: "Indica gli angoli, gli attori o i vincoli che l'analisi deve privilegiare (es. un concorrente specifico, una dimensione normativa, un territorio, un vincolo temporale…).",
			fishbone_description: 'Piano strategico - Da essere',
			fishbone_description_explanation: '',
			reference: 'Riferimento',
			tags: 'Tag',
			likelihoods: 'Probabilità',
			impacts: 'Impatti',
			types: {
				stakeholders: 'Stakeholder',
				stakeholders_long: 'Progetto stakeholder',
				stakeholders_explanation: 'Allinea le forze presenti',
				risks: 'Rischi',
				risks_long: 'Progetto rischi',
				risks_explanation: 'Trasforma i tuoi rischi in aperture',
				pro: 'Esecuzione strategia',
				pro_long: 'Progetto esecuzione strategia',
				pro_explanation: 'Implementa con agilità'
			},
			ai: {
				scenarios: {
					title: "Scenari da esplorare",
					hint: "Elaborati dall'IA privata — nessuna informazione trasmessa all'esterno. Puoi modificare il testo, l'orizzonte temporale, aggiungere o rimuovere scenari.",
					worst_label: "Peggior caso",
					worst_default: "I rischi maggiori si concretizzano, le aperture sono perse, gli stakeholder si oppongono.",
					best_label: "Miglior caso",
					best_default: "I rischi sono controllati, le aperture sono colte, gli stakeholder cooperano.",
					add: "Aggiungi uno scenario",
					remove: "Rimuovi questo scenario",
					label_placeholder: "Nome dello scenario",
					content_placeholder: "Ipotesi, eventi chiave, condizioni di realizzazione…"
				},
				horizon_unit: {
					d: "giorni",
					w: "settimane",
					m: "mesi",
					y: "anni"
				}
			},
		},
		messages: {
			delete_confirmation: 'Elimina progetto',
			delete_confirmation_explanation:
				'Sei sicuro di voler eliminare il progetto "{{name}}"? Questa azione non può essere annullata.',
			clone_confirmation: 'Clona progetto',
			clone_confirmation_explanation:
				'Sei sicuro di voler clonare questo progetto?',
			clone_in_progress:
				'Stiamo clonando il tuo progetto, attendere prego...',
			delete_in_progress:
				'Stiamo eliminando il tuo progetto, attendere prego...'
		},
		actions: {
			edit: 'Modifica progetto',
			delete: 'Elimina progetto',
			clone: 'Clona progetto',
			open: 'Apri progetto'
		}
	},
	option: {
		fields: {
			name_explanation: 'Inserisci un nome per questa opzione'
		}
	},
	item: {
		name: 'Parte interessata',
		name_plural: 'Parti interessate',
		activeness_zones: {
			external_outer_positive: 'Neutrale',
			external_inner_positive: 'Inattivo',
			external_outer_negative: 'Neutrale',
			external_inner_negative: 'Inattivo',

			internal_low_positive: 'Basso',
			internal_medium_positive: 'Medio',
			internal_high_positive: 'Alto',
			internal_low_negative: 'Basso',
			internal_medium_negative: 'Medio',
			internal_high_negative: 'Alto',

			internal_positive: 'Catalizzatori',
			internal_negative: 'Inibitori'
		},
		messages: {
			delete_confirmation: 'Elimina parte interessata',
			delete_confirmation_explanation:
				'Sei sicuro di voler eliminare questa parte interessata? Questa azione non può essere annullata e influenzerà tutti gli scenari.\n\nSe vuoi solo nascondere la parte interessata per questo scenario, chiudi questa finestra, selezionala e nella colonna destra, clicca sul pulsante "occhio" per disattivarla per questo scenario.'
		},
		fields: {
			name: 'Nome',
			description: 'Descrizione',
			links: {
				outcoming: {
					name: 'Link in uscita'
				},
				incoming: {
					name: 'Link in entrata'
				}
			},
			stakes: {
				name: 'Relazioni interessi'
			},
			indicators: {
				name: 'Relazioni indicatori'
			},
			risks: {
				name: 'Relazioni rischi'
			},
			opportunities: {
				name: 'Relazioni di aperture'
			},
			impact: {
				label: 'Importanza',
				level: {
					low: 'Basso',
					medium: 'Medio',
					high: 'Alto'
				}
			},
			trend: {
				label: 'Tonalità',
				level: {
					green: 'Positivo',
					neutral: 'Neutrale',
					orange: 'A rischio',
					red: 'Negativo'
				}
			}
		},
		actions: {
			create_new: 'Crea parte interessata',
			edit: 'Modifica dettagli',
			delete: 'Elimina parte interessata',
			clone: 'Clona parte interessata'
		},
		no_x: 'Nessuno stakeholder',
		engagement: 'Coinvolgimento',
		importance: 'Importanza',
		trust: 'Tonalità',
		levels: {
			low: 'Basso',
			medium: 'Medio',
			high: 'Alto',
			inactive_neutral: 'Inattivo / Neutrale',
			positive: 'Positivo',
			positive_short: 'Pos.',
			negative: 'Negativo',
			negative_short: 'Neg.',
			at_risk: 'A rischio',
			neutral: 'Neutrale'
		}
	},
	item_link: {
		no_x: 'Nessun link',
		actions: {
			create_new: 'Crea nuovo link'
		}
	},
	item_comment: {
		no_x: 'Nessuna cronologia',
		actions: {
			create_new: 'Crea nuova cronologia'
		}
	},
	tag: {
		name: 'Tag',
		name_plural: 'Tag',
		fields: {
			name: 'Tag',
			name_plural: 'Tag'
		},
		messages: {
			delete_confirmation: 'Elimina tag',
			delete_confirmation_explanation:
				'Sei sicuro di voler eliminare questo tag? Questa azione non può essere annullata.',
			no_x: 'Nessun tag'
		},
		actions: {
			add_x: 'Aggiungi un tag',
			create_new: 'Crea un tag',
			edit: 'Modifica tag',
			delete: 'Elimina tag'
		}
	},
	stake: {
		no_x: 'Nessun interesse',
		name: 'Interesse',
		name_plural: 'Interessi',
		fields: {
			name: 'Nome',
			reference: 'Riferimento',
			name_plural: 'Interessi',
			description: 'Descrizione',
			evaluated_at: 'Ultima valutazione',
			weight: 'Peso',
			trend: 'Stato',
			risks: {
				name: 'Relazioni rischi',
				name_positive: 'Relazioni aperture'
			},
			trend_tier: {
				strained: 'Precario',
				mixed: 'Misto',
				solid: 'Solido'
			}
		},
		actions: {
			delete: 'Elimina interesse',
			edit: 'Modifica interesse',
			create_new: 'Crea interesse'
		},
		message: {
			no_x: 'Nessun interesse'
		},
		messages: {
			delete_confirmation: 'Elimina interesse',
			delete_confirmation_explanation:
				'Sei sicuro di voler eliminare questo interesse? Questa azione non può essere annullata e influenzerà tutti gli scenari.\n\nSe vuoi solo nascondere l\'interesse per questo scenario, chiudi questa finestra, selezionalo e nella colonna destra, clicca sul pulsante "occhio" per disattivarlo per questo scenario.'
		}
	},

	indicator: {
		name: 'Indicatore',
		name_plural: 'Indicatori',
		no_x: 'Nessun indicatore',
		fields: {
			indicator_category: 'Categoria',
			name: 'Nome',
			reference: 'Riferimento',
			name_plural: 'Indicatori',
			evaluated_at: 'Ultima valutazione',
			frequency: 'Frequenza',
			weight: 'Peso',
			description: 'Descrizione'
		},
		action: {
			add_x: 'Aggiungi un punto indicatore'
		},
		message: {
			no_x: 'Nessun indicatore'
		},
		messages: {
			delete_confirmation: 'Elimina indicatore',
			delete_confirmation_explanation:
				'Sei sicuro di voler eliminare questo indicatore? Questa azione non può essere annullata e influenzerà tutti gli scenari.\n\nSe vuoi solo nascondere l\'indicatore per questo scenario, chiudi questa finestra, selezionalo e nella colonna destra, clicca sul pulsante "occhio" per disattivarlo per questo scenario.'
		},
		actions: {
			delete: 'Elimina indicatore',
			edit: 'Modifica indicatore',
			create_new: 'Crea indicatore'
		}
	},

	scenario: {
		name: 'Scenario',
		name_plural: 'Scenari',
		no_x: 'Nessuno scenario',
		baseline: 'Linea di base',
		fields: {
			name: 'Nome',
			name_long: 'Nome scenario',
			score: 'Punteggio scenario',
			description: 'Descrizione',
			impacts: 'Descrizione impatti',
			generate_simulation: 'Genera simulazione automaticamente',
			simulation_query: "Ipotesi e orizzonte temporale"
		},
		placeholders: {
			simulation_query:
				"Es.: cosa accadrebbe se il prezzo del petrolio aumentasse del 50% entro 2 anni? Quali conseguenze sugli stakeholder e sui rischi identificati?"
		},
		messages: {
			delete_confirmation: 'Elimina scenario',
			delete_confirmation_explanation:
				'Sei sicuro di voler eliminare questo scenario? Questa azione non può essere annullata.',
			creation_in_progress:
				'Attendere mentre il vostro scenario viene preparato...',
			switch_scenario: 'Passa alla linea di base o a un altro scenario',
			simulation_explanation:
				"L'IA analizzerà la tua ipotesi e proporrà modifiche agli stakeholder, ai rischi e alle poste in gioco del progetto per simulare questo scenario.",

			promote_as_baseline: {
				title: 'Promuovi questo scenario come nuova linea di base',
				explanation:
					'Sei sicuro di voler promuovere lo scenario "<0>{{name}}</0>" come nuova linea di base? Questa azione non può essere annullata.',
				keep_current_baseline_as_scenario_question:
					'Cosa vorresti fare con la linea di base precedente?',
				keep_current_baseline_as_scenario_question_yes:
					'Voglio mantenerla e darle il seguente nome',
				keep_current_baseline_as_scenario_question_no:
					'Niente, può essere eliminata',
				keep_scenario_question:
					'Vorresti mantenere una copia dello scenario ora promosso come nuova linea di base?',
				keep_scenario_question_yes: 'Sì, mantieni una copia',
				keep_scenario_question_no: 'No, non ho bisogno di una copia',
				loading: 'Promozione dello scenario in corso...'
			},

			best_evaluation: 'Miglior caso tra tutti gli scenari'
		},
		actions: {
			create_new: 'Crea un nuovo scenario',
			create_new_from_baseline: 'Crea un nuovo scenario dalla baseline',
			save_as_new_baseline: 'Salva come nuova baseline',
			clone: 'Clona scenario',
			edit: 'Modifica scenario',
			delete: 'Elimina scenario',
			next: 'Vai al prossimo scenario',
			previous: 'Vai allo scenario precedente',
			previous_baseline: 'Vai allo scenario baseline'
		}
	},
	fishbone_branch: {
		name: 'Osso',
		name_plural: 'Ossa',
		fields: {
			completion: 'Completamento',
			trend: 'Stato',
			name: 'Nome',
			description: 'Descrizione',
			weight: 'Peso',
			responsible: 'Responsabile',
			dates: 'Date',
			startOn: 'Inizio',
			endOn: 'Fine'
		},
		messages: {
			delete_confirmation: 'Elimina ramo del piano strategico',
			delete_confirmation_explanation:
				'Sei sicuro di voler eliminare questo ramo? Questa azione non può essere annullata e influenzerà tutti gli scenari.\n\nSe vuoi solo nascondere il ramo per questo scenario, chiudi questa finestra, selezionalo e nella colonna destra, clicca sul pulsante "occhio" per disattivarlo per questo scenario.'
		},
		actions: {
			add: 'Aggiungi un osso',
			clone: 'Clona osso',
			edit: 'Modifica osso',
			delete: 'Elimina osso'
		}
	},
	fishbone_item: {
		name: 'Sotto-osso',
		name_plural: 'Sotto-ossa',
		fields: {
			name: 'Nome',
			description: 'Descrizione',
			completion: 'Completamento',
			trend: 'Stato',
			weight: 'Peso',
			responsible: 'Responsabile',
			startOn: 'Inizio',
			endOn: 'Fine',
			dates: 'Date'
		},
		messages: {
			delete_confirmation: 'Elimina sotto-osso',
			delete_confirmation_explanation:
				'Sei sicuro di voler eliminare questa misura? Questa azione non può essere annullata e influenzerà tutti gli scenari.\n\nSe vuoi solo nascondere la misura per questo scenario, chiudi questa finestra, selezionala e nella colonna destra, clicca sul pulsante "occhio" per disattivarla per questo scenario.'
		},
		actions: {
			add: 'Aggiungi un sotto-osso',
			clone: 'Clona sotto-osso',
			edit: 'Modifica sotto-osso',
			delete: 'Elimina sotto-osso'
		}
	},
	risk: {
		name: 'Rischio',
		name_plural: 'Rischi',
		name_positive: 'Apertura',
		name_plural_positive: 'Aperture',
		fields: {
			name: 'Nome',
			description: 'Descrizione - Indicatori di occorrenza',
			reference: 'Riferimento',
			risk_category: 'Categoria',
			likelihood: 'Probabilità',
			likelihood_level: 'Nome del livello di probabilità',
			impact: 'Impatto',
			impact_level: "Nome del livello d'impatto",
			matching_opportunity: 'Apertura',
			matching_risks: 'Rischi',
			evaluated_at: 'Ultima valutazione',
			exposure: 'Esposizione',
			exposure_positive: 'Potenziale',

			opportunity: {
				name: 'Apertura'
			}
		},
		messages: {
			delete_confirmation: 'Elimina rischio',
			delete_confirmation_explanation:
				'Sei sicuro di voler eliminare questo rischio? Questa azione non può essere annullata e influenzerà tutti gli scenari.\n\nSe vuoi solo nascondere il rischio per questo scenario, chiudi questa finestra, selezionalo e nella colonna destra, clicca sul pulsante "occhio" per disattivarlo per questo scenario.',
			delete_opening: 'Elimina apertura',
			delete_opening_explanation:
				'Sei sicuro di voler eliminare questa apertura? Questa azione non può essere annullata e influenzerà tutti gli scenari.\n\nSe vuoi solo nascondere l\'apertura per questo scenario, chiudi questa finestra, selezionala e nella colonna destra, clicca sul pulsante "occhio" per disattivarla per questo scenario.',
			no_x: 'Nessun rischio',
			no_category: 'Nessuna categoria',
			no_x_positive: 'Nessuna apertura'
		},
		impacts: {
			1: 'Trascurabile',
			2: 'Minore',
			3: 'Moderato',
			4: 'Maggiore',
			5: 'Estremo'
		},
		likelihoods: {
			1: 'Molto improbabile',
			2: 'Improbabile',
			3: 'Possibile',
			4: 'Probabile',
			5: 'Quasi certo'
		},
		actions: {
			create_new: 'Crea nuovo rischio o apertura',
			edit: 'Modifica rischio',
			edit_opportunity: 'Modifica apertura',
			delete: 'Elimina rischio',
			delete_opportunity: 'Elimina apertura'
		}
	},
	risk_category: {
		name: 'Categoria',
		name_plural: 'Categorie',
		fields: {
			name: 'Nome'
		},
		messages: {
			delete_confirmation: 'Elimina categoria',
			delete_confirmation_explanation:
				'Sei sicuro di voler eliminare questa categoria? Questa azione non può essere annullata.',
			no_x: 'Nessuna categoria'
		},
		actions: {
			create_new: 'Crea una nuova categoria',
			edit: 'Modifica categoria',
			delete: 'Elimina categoria',
			add_x: 'Aggiungi una categoria'
		},
		default_values: {
			name: {
				1: 'Esistenziale',
				2: 'Strategica',
				3: 'Operativa'
			}
		}
	},
	indicator_category: {
		name: 'Categoria',
		name_plural: 'Categorie',
		fields: {
			name: 'Nome'
		},
		messages: {
			delete_confirmation: 'Elimina categoria',
			delete_confirmation_explanation:
				'Sei sicuro di voler eliminare questa categoria? Questa azione non può essere annullata.',
			no_x: 'Nessuna categoria',
			unassigned: 'Non assegnata'
		},
		actions: {
			create_new: 'Crea una nuova categoria',
			edit: 'Modifica categoria',
			delete: 'Elimina categoria',
			add_x: 'Aggiungi una categoria'
		},
		default_values: {
			name: {
				1: 'Finanziaria',
				2: 'Clienti',
				3: 'Processi interni',
				4: 'Apprendimento e crescita'
			}
		}
	},
};
